import React from "react";

const ProfileInfo = ({ label, value }) => (
  <div>
    <p className="text-[11px] uppercase tracking-[0.3em] text-zinc-500">{label}</p>
    <p className="mt-2 text-lg text-white">{value || "Not provided"}</p>
  </div>
);

export default ProfileInfo;
